<template>

    <article class="interview">
        <header>
            <h1>
                <span>Interview<br> des</span>
                dirigeants
            </h1>
        </header>

        <main>

            <figure>
                <div>
                    <img :src="require('../assets/inteview.jpg')" alt="">
                    <figcaption>
                        <span>Notre raison </span>
                        <span>d'être et nos</span>
                        <span>raisons d'agir</span>
                    </figcaption>
                </div>
                <div class="legend">
                    <div class="legend-item">
                        <span>Gauche</span>
                        <strong>Jean-Yves Dagès,</strong>
                        Président
                    </div>

                    <div class="legend-item">
                        <span>Droite</span>
                        <strong>Thierry Martel,</strong>
                        Directeur Général

                    </div>
                </div>

            </figure>


            <section>

                <h2>Quelle a été la tonalité de 2019&nbsp;? Que retenir de l’année écoulée&nbsp;?</h2>

                <p>
                    <strong>Jean-Yves Dagès : </strong> 2019 a été une année complexe, tant sur le plan économique et
                    social qu’environnemental, à l’image sans doute d’un monde en transition porteur de défis et
                    d’opportunités. <br>
                    2019 a été marquée par une persistance des taux bas, avec ponctuellement des taux négatifs pouvant
                    menacer les équilibres financiers.
                    Une année également marquée par un contexte social global tendu qui a vu s’exprimer les
                    préoccupations des français sur les sujets de la mobilité, de la santé et de la retraite.
                    D’importantes réformes ont été adoptées avec la loi PACTE en avril et la mise en place du 100%
                    santé. <br>
                    Enfin, l’année écoulée nous a rappelé l’importance des questions environnementales. <br>
                    2019 ne nous a pas épargnés une fois de plus sur le plan climatique, avec une alternance d’épisodes
                    de forte canicule, de sécheresse et d’inondations qui nous ont conduits notamment à verser 250
                    millions d’euros de sinistres bruts à nos agriculteurs sociétaires.

                </p>

            </section>


            <section>

                <h2>Dans ce contexte difficile, quel est le bilan que vous tirez pour Groupama ? </h2>

                <p>
                    <strong>Thierry Martel : </strong> Dans ce contexte incertain, le Groupe Groupama a affiché des
                    résultats très satisfaisants portés par notre activité en France. Ce qui prouve notre solidité. <br>
                    Parmi les indicateurs de cette bonne santé, je soulignerais la poursuite de la croissance organique
                    rentable. Notre chiffre d’affaires progresse de +1,7% à 14,4 milliards d’euros au 31 décembre et
                    notre résultat opérationnel augmente de +32% à 413 millions d’euros.<br>
                    L’ensemble de nos caisses régionales a gagné encore des clients, démontrant notre dynamisme et notre
                    compétitivité. <br>
                    A souligner aussi, le lancement réussi de notre plan épargne retraite avec déjà plus de 8.000 PER
                    ouverts au 31 décembre 2019, trois mois après sa mise en œuvre ! <br>
                    Les différentes entreprises du Groupe ont poursuivi leur transformation digitale, en développant de
                    nouvelles solutions mobiles ainsi qu’en nouant des partenariats innovants. <br>
                    Ces très bonnes performances ont aussi démontré notre capacité à intégrer les enjeux sociaux et
                    environnementaux dans notre stratégie et nos actions.
                    <br>
                    Un autre facteur de satisfaction est le relèvement de notre note de solidité financière à ‘A’ par
                    Fitch Rating, avec le maintien de la perspective positive*.<br> Nous avons consolidé notre situation
                    financière pour mieux préparer l’avenir. En témoigne, notre solvabilité qui est élevée avec un ratio
                    de couverture de 302% au 31 décembre 2019.

                </p>

                <p>
                    <strong>Jean-Yves Dagès : </strong> A souligner également, la progression de la marque Groupama en
                    matière de notoriété. Les récentes campagnes publicitaires exprimant nos valeurs mutualistes ont
                    reçu un écho très positif auprès du grand public, tout comme notre engagement aux côtés de l’Equipe
                    cycliste Groupama-FDJ.
                </p>

            </section>
            <blockquote>
                <div class="image jean-yves-dages"></div>
                <p>
                    Nous sommes plus que jamais attachés à porter un mutualisme d’actions à l’oeuvre concrètement chaque
                    jour.
                    <cite>Jean-Yves Dagès</cite>
                </p>
            </blockquote>
            <section>

                <h2>Quelles sont vos perspectives pour les années à venir ?</h2>

                <p>
                    <strong>Thierry Martel : </strong> Pour relever les défis du futur et être performants, il nous faut
                    continuer à créer de la valeur sur nos métiers, maîtriser notre rentabilité, notre performance
                    opérationnelle dans un contexte général, économique et environnemental toujours plus changeant et
                    concurrentiel. Trois pans de notre activité sont directement impactés par ce contexte : le secteur
                    de la mobilité en prise directe avec les questions environnementales, celui de la santé, et celui de
                    l’épargne et de la retraite. Il convient pour chacun d’enrichir notre offre par des services
                    toujours plus utiles et innovants, adaptés aux besoins de chacun.

                </p>

                <p>
                    <strong>Jean-Yves Dagès : </strong> Pour cela, il faut que nous soyons techniquement excellents, que
                    nous maîtrisions nos coûts, tout en valorisant l’humain, notamment via la formation de nos élus et
                    de nos collaborateurs afin de leur permettre d’appréhender ces nouveaux enjeux pour une prise en
                    charge toujours plus optimale de nos assurés.
                </p>

                <p>
                    <strong>Thierry Martel : </strong> Il faut en effet que nous soyons capables de créer un écosystème
                    client qui mixe digital et réseau physique. Un écosystème dans lequel la place de l’humain sera
                    prépondérante même si l’intermédiation se fait grâce au digital. Offres digitales, solutions
                    connectées et cyber sécurité, il s’agit là d’une réelle source d’opportunités nouvelles pour les
                    différentes entreprises du Groupe sur lesquelles, elles se sont déjà largement positionnées.
                </p>

                <p>
                    <strong>Jean-Yves Dagès : </strong> Autre enjeu, celui des transitions qui impactent directement le
                    monde agricole, avec le dérèglement climatique, mais aussi le développement de circuits-courts, la
                    transition énergétique, le risque cyber… nous mettons tout en œuvre pour répondre aux nouvelles
                    attentes et aux nouveaux risques du secteur en étant à l’écoute de ses évolutions. Groupama compte
                    bien en effet ces prochaines années demeurer un partenaire d’excellence et le premier assureur du
                    monde agricole. De ce point de vie 2019 a vu de nombreuses contributions de notre groupe aux travaux
                    sur la gestion des risques en agriculture pour favoriser la résilience des exploitations.
                </p>


            </section>

            <blockquote class="reverse">
                <div class="image thierry-martel"></div>
                <p>
                    Nous avons consolidé notre situation financière pour mieux préparer l’avenir.
                    <cite>Thierry Martel</cite>
                </p>
            </blockquote>

            <section>

                <h2>Quelle est la ligne directrice du Groupe ?</h2>

                <p>
                    <strong>Jean-Yves Dagès : </strong> Elle tient dans notre raison d’être. «&nbsp;Nous sommes là pour
                    permettre au plus grand nombre de construire leur vie en confiance.&nbsp;» Pour cela nous sommes
                    fondés sur des communautés d’entraide humaines, proches et responsables. <br>
                    Nous sommes plus que jamais attachés à porter un mutualisme d’actions à l’œuvre concrètement chaque
                    jour, avec les outils d’aujourd’hui, et grâce à l’engagement de nos élus et de nos
                    collaborateurs.<br>
                    C’est dans notre ADN. Ce sont ces valeurs qui fondent notre identité depuis plus d’un siècle :
                    solidarité, responsabilité, proximité, optimisme… Des valeurs intemporelles, inscrites dans le cœur
                    des femmes et des hommes qui sont et qui font Groupama au quotidien.

                </p>

                <p>
                    <strong>Thierry Martel : </strong> Une raison d’être qui s’inscrit dans la durée, motive et oriente
                    nos actions comme nos projets, nous engage et nous guide pour réinventer nos métiers, et servir
                    toujours au mieux nos clients et sociétaires, en mettant l’humain au cœur de nos relations.<br>
                    Clients sociétaires, agriculteurs, collectivités, entreprises et professionnels, retraités, élus,
                    collaborateurs et partenaires sont pour nous autant de raisons d’agir. Elles motivent nos actions et
                    leur donnent du sens.<br>
                    A nous tous d’être acteurs et porteurs de notre raison d’être. Une détermination forte pour
                    incarner, jour après jour, un modèle de mutualisme engagé et dynamique, un mutualisme d’avenir.
<br><br>*Le 19 mars 2020, Fitch a révisé la perspective associée à la notation de Groupama à 'Stable' et maintenu la notation à 'A'
                </p>

            </section>

            <nav>
                <router-link to="/etre" class="nav-etre nav-button">Être</router-link>
                <div class="nav-line"></div>
                <router-link to="/agir" class="nav-agir nav-button">Agir</router-link>
            </nav>

            <a href="#top" class="scrollTop" @click.prevent="goTop()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95 55">
                    <polygon points="95 47.5 47.5 0 0 47.5 7.6 55 47.5 15.1 87.4 55 95 47.5"/>
                </svg>
            </a>

        </main>

    </article>

</template>

<script>
    export default {
        name: "Interview",
        methods: {
            goTop() {
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                })
            }
        }
    }
</script>

<style scoped lang="scss">

    .interview {
        background: #005848;
        display: flex;
        flex-direction: column;
        align-items: center;

        header {
            background: #006b58;
            align-self: normal;
            width: 100%;
        }

        main {
            max-width: 1130px;
            margin: 75px auto 0;
            padding: 0 15px;

        }

        section {
            padding-left: 90px;
            display: flex;
            flex-direction: column;

            p {
                color: white;
                font-size: 18px;
                line-height: 23px;
                font-weight: 300;

                strong {
                    font-weight: 800;
                }
            }
        }

        h1 {
            display: flex;
            font-weight: 900;
            text-transform: uppercase;
            justify-content: center;
            font-size: 170px;
            line-height: 1;
            color: #004135;
            margin-bottom: 60px;
            margin-top: 60px;

            span {
                text-align: right;
                color: #a1bf38;
                font-weight: 700;
                margin-right: 30px;
                font-size: 40px;
                line-height: 42px;
                transform: translateY(5%);
            }
        }

        h2 {
            color: #a1bf38;
            font-size: 26px;
            line-height: 35px;
            font-weight: 700;
        }

        blockquote {
            margin: 0;
            color: #669b91;
            max-width: 720px;
            margin-left: calc(90px + 90px);
            position: relative;
            margin-bottom: 100px;
            margin-top: 100px;

            .image {
                position: absolute;
                left: -220px;
                width: 150px;
                height: 150px;
                border-radius: 50%;
                display: block;
            }

            p {
                font-weight: 700;
                color: #669b91;
                font-size: 30px;
                line-height: 35px;
                position: relative;

                &::before {
                    content: '';
                    background-position: center center;
                    background-repeat: no-repeat;
                    background-image: url('../assets/quote2.svg');
                    width: 67px;
                    height: 48px;
                    display: block;
                    position: absolute;
                    left: -90px;
                    top: 0;
                }

            }

            cite {
                font-size: 22px;
                font-weight: 500;
                line-height: 45px;
            }

            &.reverse {
                margin-left: auto;
                margin-right: 90px;

                .image {
                    left: auto;
                    right: -220px;
                }

                p {
                    text-align: right;

                    &::before {
                        left: 0;
                        right: -90px;
                        margin-left: auto;
                        transform: scale(-1, 1);
                    }

                }
            }

        }

        figure {
            position: relative;
            margin: 0;
            display: flex;

            img {
                display: block;
                background: #8b8b8b;
                max-width: 100%;
                height: auto;
                width: 100%;
            }

            figcaption {
                font-size: 30px;
                line-height: 32px;
                color: white;
                text-transform: uppercase;
                font-weight: 700;
                display: flex;
                flex-direction: column;
                transform: translateY(calc(-100% / 3));

                span {
                    background-color: #a1bf38;
                    padding: 2px;
                    align-self: flex-start;

                }
            }

            .legend {
                display: flex;
                flex-direction: column;
                margin-left: 30px;

                &-item {
                    display: flex;
                    flex-direction: column;
                    text-transform: uppercase;
                    color: white;
                    margin-bottom: 30px;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    span {
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        margin-bottom: 6px;
                        font-size: 14px;
                        font-style: italic;
                        text-transform: initial;

                    }

                    strong {
                        display: block;
                    }
                }
            }

        }

        .scrollTop {
            background: #004135;
            border-radius: 50%;
            width: 52px;
            height: 52px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: auto;
            margin-bottom: 100px;
            margin-top: 100px;

            svg {
                fill: white;
                width: 19px;
                height: 11px;
            }
        }

        .jean-yves-dages {
            background: url(../assets/jy-dages.jpg) center center no-repeat;
            background-size: cover;
        }

        .thierry-martel {
            background: url(../assets/t-martel.jpg) center center no-repeat;
            background-size: cover;
        }

    }

    nav {
        border-top: 1px solid #00352c;
        padding: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 60px;
        margin-bottom: 0;
        padding-bottom: 0;

        .nav {
            &-line {
                width: 1px;
                background: #00352c;
                height: 130px;
                transform: translateY(-15%);
            }

            &-button {
                font-size: 170px;
                font-weight: 900;
                text-transform: uppercase;
                text-decoration: none;
                margin-right: 45px;
                margin-left: 45px;
                opacity: .5;
                transition: .25s ease;
                position: relative;
                line-height: 1.3 !important;

                &:hover {
                    opacity: 1;
                }

                &.nav-etre {
                    color: #a1bf38;

                }

                &.nav-agir {
                    color: #004135;
                }

            }
        }

    }

    @media screen and (max-width: 1480px) {

        .interview {

            blockquote {
                margin: auto !important;

                .image {
                    position: static;
                    margin: auto !important;
                }

                p {
                    text-align: center !important;
                }
            }

            main {
                padding: 0 25px;
            }

            h1 {
                font-size: 100px;

                span {
                    line-height: 1;
                }
            }
        }
    }


    @media screen and (max-width: 1280px) {
        nav {
            .nav {
                &-button {
                    font-size: 100px;
                }
            }
        }
    }

    @media screen and (max-width: 1000px) {


        nav {
            .nav {
                &-button {
                    font-size: 60px;
                }
            }
        }

        .interview {

            section {
                padding-left: 50px;

                p {
                    font-size: 16px;
                }
            }

            blockquote {

                p::before {
                    content: none !important;
                }

                p {
                    font-size: 21px;
                    line-height: 32px;
                }
            }

            h2 {
                font-size: 21px;
                line-height: 30px;
            }

            main {
                max-width: 100%;
                padding: 0 25px;
            }


            h1 {
                flex-direction: column;
                font-size: 50px;
                text-align: center;

                span {
                    font-size: 30px;
                    text-align: center;
                    margin-left: 30px;
                    line-height: 1;

                    br {
                        display: none;
                    }
                }
            }

            figure {
                flex-direction: column;

                .legend {
                    margin-left: 0;
                    flex-direction: row;
                    align-items: flex-start;

                    &-item {
                        font-size: 14px;
                        text-align: center;
                        width: calc(50% - 10px);
                        margin-left: 5px;
                        margin-right: 5px;

                        span {
                            margin: 0 auto 10px;
                        }
                    }

                }

            }
        }

    }


    @media screen and (max-width: 780px) {

        nav .nav-button {
            margin-left: 25px;
            margin-right: 25px;
        }

        nav .nav-line {
            height: 40px;
        }

        .interview {
            header {
                margin-top: 90px;
            }

            blockquote {
                .image {
                    width: 150px;
                    height: 150px;
                }

                cite {
                    font-size: 18px;
                    line-height: 21px;
                    display: block;
                    margin-top: 10px;
                }

                p {
                    font-size: 18px;
                    line-height: 21px;
                }
            }
        }
    }

    @media screen and (max-width: 480px) {
        .interview {
            section {
                padding-left: 0;
            }
            header {
                margin-top: 50px;
            }

            h2 {
                font-size: 20px;
            }
        }

        .interview figure figcaption {
            display: block;
            font-size: 20px;
            line-height: 22px;
        }

        nav .nav-button {
            font-size: 40px;
        }

        nav .nav-line {
            display: none;
        }
    }

</style>
